module.exports = __webpack_public_path__ + "static/exams-4e89d7b3aceaf426d4787dd4d77159b2.svg";